import React, { useEffect, useState } from "react";
import "./stages.css";
import { useTranslation } from "react-i18next";

const Stages = () => {
  const { t, i18n } = useTranslation();
  
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      localStorage.setItem("lng", lng);
    };
  
    useEffect(() => {
      changeLanguage(localStorage.getItem("lng") || "en");
    }, []);
  const steps = [
    { id: "01", title: t("stages_text1") },
    { id: "02", title: t("stages_text2") },
    { id: "03", title: t("stages_text3") },
    { id: "04", title: t("stages_text4") },
    { id: "05", title: t("stages_text5") },
  ];

  const [visibleStep, setVisibleStep] = useState(0);

  useEffect(() => {
    const stagesElement = document.getElementById("stages-container");

    if (visibleStep < steps.length) {
      stagesElement.classList.remove("scrolling-enabled"); // Отключаем скролл
      setTimeout(() => {
        setVisibleStep((prev) => prev + 1);
      }, 600); // 600 мс на каждый элемент
    } else {
      stagesElement.classList.add("scrolling-enabled"); // Включаем скролл
    }
  }, [visibleStep, steps.length]);

  return (
    <div className=" py-10  from-primary/100 to-primaryDark/70 backdrop-blur-lg bg-gradient-to-r" id="stages-container">
      <div className="stages-header my-14">
        <h2 className="text-center text-white text-4xl font-bold">{t("stages_header")}</h2>
      </div>
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative">
          {/* Линия таймлайна */}
          <div className="absolute left-1/2 top-0 h-full w-1 bg-white transform -translate-x-1/2"></div>
          {/* Элементы */}
          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`relative flex items-center sm:mb-2 mb-4 transition-all duration-700 ease-out transform ${
                index % 2 === 0 ? "justify-center md:justify-start" :  " justify-center md:justify-end"
              } ${
                index < visibleStep
                  ? "opacity-100 translate-y-0 animate__fadeInUp"
                  : "opacity-0 translate-y-12"
              }`}
            >
              {/* Точка */}
              <div className="timeline-dot absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-primary rounded-full border-4 border-white z-5"></div>
              {/* Текст */}
              <div
                className={`bg-white  transition-all duration-300 hover:scale-110 p-6 rounded-lg shadow-md max-w-lg w-full ${
                  index % 2 === 0
                    ? "lg:ml-10 md:text-left text-center"
                    : "lg:mr-10 text-center md:text-right"
                }`}
              >
                <h3 className="text-xl font-bold text-gray-600 mb-2">{step.id}</h3>
                <p className="text-gray-600">{step.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stages;
